export default __webpack_public_path__ + "assets/group-background.daf782321c7f65cde0fc3d5918d27762.png";